import { render, staticRenderFns } from "./OrderBill.vue?vue&type=template&id=679f19c8&scoped=true&"
import script from "./OrderBill.vue?vue&type=script&lang=js&"
export * from "./OrderBill.vue?vue&type=script&lang=js&"
import style0 from "./OrderBill.vue?vue&type=style&index=0&id=679f19c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679f19c8",
  null
  
)

export default component.exports